import React from 'react';
import { connect } from 'react-redux';

import { withCookies, Cookies } from 'react-cookie';
import { updateLegacySessionKey } from '../../store/actions';
import { pullCampaignScripts, updateOrCreateScript } from '../../store/api/calls';
import { updateScript } from '../../store/actions';

import { updateCampaignAggregates, getFocusedCampaign } from '../../store/api/calls';
import api from '../../store/api/api';
import { siteCanvassEditCreateForm } from '../../utils/forms/formFields';
import { navigateAway } from '../../utils/nav';
import { Link } from 'react-router-dom';

import NavBaseTemplate from '../templates/NavBaseTemplate';
import BaseForm from '../theme/forms/BaseForm';
import DataTable from '../theme/tables/DataTable';
import BaseModal from '../theme/modals/BaseModal';
import FeedbackTile from '../theme/modals/FeedbackTile';
import Moment from 'moment';
import SETTINGS from '../../settings';
import * as formFields from '../../utils/forms/formFields';

class ScriptScreen extends React.Component {
  // static propTypes = {
  // 	cookies: instanceOf(Cookies).isRequired
  // };

  constructor(props) {
    super(props);

    this.state = {
      deleteModalOpen: false,
      publishModalOpen: false,
      scriptCreateModelOpen: false,
      publishSuccess: false,
      loading: false,
      error: false,
      editingInstance: {},
      feedbackTileVisibile: true,
      // feedbackTileColor: ,
    };

    this.formInputs = siteCanvassEditCreateForm;
  }

  componentDidMount() {
    const legacyCookie = this.props.cookies.get('sessionid_wox_legacy');
    this.props.updateLegacySessionKey(legacyCookie);
    this.handleMountOrCampaignUpdate();
  }

  componentDidUpdate(prevProps) {
    if (this.props.focusedCampaign !== prevProps.focusedCampaign) {
      this.handleMountOrCampaignUpdate();
    }
  }

  handleMountOrCampaignUpdate = () => {
    pullCampaignScripts();
  };

  launchCreateScriptModal = () => {
    this.setState({
      scriptCreateModelOpen: true,
    });
  };

  onCloseCreateScriptModal = () => {
    this.setState({
      scriptCreateModelOpen: false,
    });
  };

  handleCreateScriptRequest = (data) => {
    const { name } = data;
    api.get('/script/new/', { script_name: name }).then((res) => {
      this.props.history.push(`/script/${res.data.script_id}/edit`);
      // window.location.href = 'https://scripts.wox-campaigns.com' + '?s=' + res.data.script_id;
    });
  };

  onOpenPublishModal = (modelInstance) => {
    this.setState({ publishModalOpen: true, editingInstance: modelInstance });
  };

  onClosePublishModal = () => {
    this.setState({ publishModalOpen: false });
    this.setState({ editingInstance: {} });
  };

  handlePublishScriptRequest = () => {
    const { id: script_id, draft_revision_num: revision_num } = this.state.editingInstance;

    this.setState({ loading: true });
    api.get('/script/publish/', { script_id, revision_num }).then((res) => {
      this.setState({ loading: false, publishSuccess: true });
      this.onClosePublishModal();
      setTimeout(() => this.setState({ publishSuccess: false }), 4000);
      updateScript(res.data);
    });
  };

  onOpenDeleteModal = (modelInstance = {}) => {
    this.setState({ deleteModalOpen: true, editingInstance: modelInstance });
  };

  onCloseDeleteModal = () => {
    this.setState({ deleteModalOpen: false, editingInstance: {} });
  };

  handleRemoveSubmission = () => {
    const id = this.state.editingInstance.id;
    const data = { is_active: false, id };

    updateOrCreateScript(data).then(this.onCloseDeleteModal());
  };

  _filterKeysForDataTable() {
    return this.props.scripts.map((d) => ({
      name: <Link to={`/script/${d.id}/edit`}>{d.name}</Link>,
      _name: d.name,
      lastest_draft_revision: d.draft_revision_num,
      published_revision: d.pub_revision_num || '--',
      _published_revision: d.pub_revision_num || 0,
      created_on: new Moment(d.created_at).format('MM/DD/YY'),
      _created_on: new Moment(d.created_at),
      _data: d,
    }));
  }

  render() {
    return (
      <NavBaseTemplate location={this.props.location} showAdmin={this.props.is_admin}>
        <div className="button-table-top-wrapper">
          <a className="button" onClick={this.launchCreateScriptModal}>
            + Create Script
          </a>
        </div>
        <DataTable
          data={this._filterKeysForDataTable() || []}
          title="Scripts"
          actions={[
            {
              title: 'publish',
              icon: 'fa-upload',
              action: (modelInstance) => this.onOpenPublishModal(modelInstance),
            },
          ]}
        />

        <FeedbackTile
          text={
            <div>
              <i className=" fas fa-asterisk fa-spin" style={{ marginRight: '15px' }} />
              Loading...
            </div>
          }
          visible={this.props.loading}
        />

        <FeedbackTile
          text={
            <div>
              <i className=" fas fa-check-circle" style={{ marginRight: '15px' }} />
              Script Published
            </div>
          }
          visible={this.state.publishSuccess}
        />

        <BaseModal
          open={this.state.scriptCreateModelOpen}
          onClose={this.onCloseCreateScriptModal}
          center
        >
          <BaseForm
            inputs={[formFields.genericName]}
            onCancel={this.onCloseCreateScriptModal}
            onSubmit={this.handleCreateScriptRequest}
          />
        </BaseModal>

        <BaseModal
          open={this.state.publishModalOpen}
          onClose={this.onClosePublishModal}
          onSubmit={this.handlePublishScriptRequest}
          center
        >
          <div className="modal-internal-wrapper">
            <p>
              Are you sure you want to publish the script <b>{this.state.editingInstance.name}</b>?
            </p>
            <div className="button-wrapper">
              <div className="button" onClick={this.handlePublishScriptRequest}>
                Publish
              </div>
              <div className="button button-outline" onClick={this.onClosePublishModal}>
                Cancel
              </div>
            </div>
          </div>
        </BaseModal>
      </NavBaseTemplate>
    );
  }
}

const mapStateToProps = (state) => ({
  campaigns: state.session.campaigns,
  focusedCampaign: state.session.focusedCampaign,
  scripts: state.scripts.data,
  loading: state.scripts.loading,
  error: state.scripts.error,
  is_admin: state.permissions.is_admin,
});

//tHIS NEEDS tO MOVE tO tHE tEMPLAtE SCREEN!
const mapDispatchToProps = (dispatch) => ({
  updateLegacySessionKey: (key) => dispatch(updateLegacySessionKey(key)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withCookies(ScriptScreen));
